import worldforum from "@/assets/partner-worldforum.png";
import denhaag from "@/assets/partner-denhaag.jpg";
import allsafe from "@/assets/partner-allsafe.svg";
import verhuisoffertes from "@/assets/partner-verhuisoffertes.svg";
import trustoo from "@/assets/partner-trustoo.svg";
import willemsAsset from "@/assets/partner-willems.jpg.asset.json";
import vloervitaalAsset from "@/assets/partner-vloervitaal.jpg.asset.json";
import tiktok from "@/assets/partner-tiktok.svg";

type Partner = {
  name: string;
  logo: string;
  href: string;
  note: string;
  tall?: boolean;
};

export const partners: Partner[] = [
  {
    name: "World Forum The Hague",
    logo: worldforum,
    href: "https://www.worldforum.nl/",
    note: "Logistieke coördinatie bij congressen en evenementen",
    tall: true,
  },
  {
    name: "Gemeente Den Haag",
    logo: denhaag,
    href: "https://www.denhaag.nl/",
    note: "Logistiek, opbouw en afbouw van alle stemlocaties bij verkiezingen",
  },
  {
    name: "AllSafe mini opslag",
    logo: allsafe,
    href: "https://www.allsafe.nl/",
    note: "Tijdelijke opslag van inboedel en kantoorinventaris",
  },
  {
    name: "VerhuisOffertes",
    logo: verhuisoffertes,
    href: "https://www.verhuisoffertes.com/verhuizers/ee4nz/vakkundig-verhuizingen-transport/",
    note: "Aangesloten verhuizer met beoordelingen van klanten",
  },
  {
    name: "Trustoo",
    logo: trustoo,
    href: "https://trustoo.nl/zuid-holland/den-haag/verhuisbedrijf/vakkundig-verhuizingen-transport-/",
    note: "Erkend profiel met verifieerde klantbeoordelingen",
  },
  {
    name: "Willems Electrotechnisch Buro",
    logo: willemsAsset.url,
    href: "https://www.willems-etb.nl/",
    note: "Samenwerking met erkend elektrotechnisch installateur",
  },
  {
    name: "Vloervitaal",
    logo: vloervitaalAsset.url,
    href: "https://vloervitaal.nl/",
    note: "Samenwerking voor professionele vloerreiniging en vloeronderhoud",
  },
  {
    name: "TikTok",
    logo: tiktok,
    href: "https://www.tiktok.com/@vakkundig.verhuiz",
    note: "Volg onze verhuizingen en verhuislift in actie op TikTok",
  },
];

export function PartnerLogos({ compact = false }: { compact?: boolean }) {
  return (
    <ul
      className={`grid gap-4 ${
        compact ? "grid-cols-3 sm:grid-cols-6" : "grid-cols-2 sm:grid-cols-3 lg:grid-cols-6"
      }`}
    >
      {partners.map((p) => (
        <li key={p.name}>
          <a
            href={p.href}
            target="_blank"
            rel="noopener noreferrer nofollow"
            title={`${p.name} — ${p.note}`}
            className="flex h-full flex-col items-center justify-center gap-3 rounded-xl border border-border bg-background p-4 transition hover:border-brand hover:shadow-sm"
          >
            <img
              src={p.logo}
              alt={`Logo ${p.name}`}
              loading="lazy"
              className={`w-auto object-contain ${p.tall ? "h-14" : "h-10"}`}
            />
            {!compact ? (
              <span className="text-center text-xs font-semibold leading-snug text-secondary">
                {p.name}
              </span>
            ) : null}
          </a>
        </li>
      ))}
    </ul>
  );
}
